<ion-tabs (ionTabsDidChange)="onIonTabChange($event)">
  <ion-tab-bar slot="top" class="bottom-edge-shadow" #iontabbar>
    <ion-tab-button
      *ngFor="let tab of tabList | kzSort: 'displayOrder'"
      [tab]="tab.path"
      [layout]="'icon-start'"
    >
      <ion-icon [name]="tab.icon"></ion-icon>
      <ion-label class="">{{ tab.label }}</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
